export type SoloWidgetState = {
  sessionId?: string
  appId?: string
  nodeName?: string
  nodeId?: string
  show: boolean;
  isUnreadMessage?: boolean;
  messageCount?: number;
  scroll?:boolean;
};

const initialState = {
  show: false,
  isUnreadMessage: false,
  scroll: false,
} as const;

type SoloWidgetAction = {
  type: "SET_SHOW_SOLO_WIDGET";
  payload: boolean;
} | {
  type: "INIT_SOLO_WIDGET_SESSION"
  payload: {
    sessionId: string
    appId: string
    nodeName: string
    nodeId: string
  }
} | {
    type: "SET_UNREAD_MESSAGE";
    payload: {
      isUnreadMessage : boolean,
      messageCount : number ,
      scroll : boolean,
      isWaitingForm: boolean,
    }
  };

export default function soloWidgetReducer(state: SoloWidgetState = initialState, action: SoloWidgetAction): SoloWidgetState {
  switch (action.type) {
    case "INIT_SOLO_WIDGET_SESSION": {
      return {
        ...state,
        ...action.payload
      };
    }
    case "SET_SHOW_SOLO_WIDGET": {
      return {
        ...state,
        show: action.payload,
      };
    }
     case "SET_UNREAD_MESSAGE":
      return {
        ...state,
        ...action.payload
      };
    default: {
      return state;
    }
  }
}
